import axios from '../axios';
import config from '../config';
import qs from 'qs';

/**
 * 
 * @module http/loginTGCOST 登录天工模块  
 */


/**
 *
 *登录天工
 * @export
 * @param {object} data 账号，密码，验证码
 * @return {promise} 
 */
export async function login(data) {
    let ret;
    let str = await axios({ url: 'captchaStr', method: 'get' });
    console.log(str);
    if (str.data != data.captcha) {
        ret = { msg: '验证码不正确' };
    } else {
        ret = await axios({
            baseUrl: config.loginTGurl,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            url: 'login',
            method: 'post',
            data: qs.stringify(data)
        });
        console.log(ret);
        if (ret.msg != null && ret.msg != "") {

        } else {
            console.log("登录天工成功!");
            console.log("开始将authentication set到SecurityContextHolder并生成jwt token，返回JwtAuthenticatioToken。");
            ret = await axios({
                url: 'login1',
                method: 'get'
            });
            let status = ret.code;
            if (status == 200) {
                console.log(ret.data.token);
            } else {
                alert(ret.msg);
            }
        }
    }
    return ret;
};

export function checkLoginStatus() {
    let promise = axios({ url: "/checkLoginStatus", method: "get" });
    return promise;
};

// 后台生成权限数据



// WEBPACK FOOTER //
// ./src/http/modules/loginTGCOST.js